import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../services/firebase";

export const isDuplicateUrl = async (
  collectionName: string,
  url: string
): Promise<boolean> => {
  try {
    const q = query(
      collection(db, collectionName),
      where("url", "==", url.trim())
    );
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty;
  } catch (error) {
    console.error(
      `Failed to check for duplicate URL in ${collectionName}:`,
      error
    );
    return false;
  }
};
